import type { User } from "firebase/auth";

/**
 * A one-bit, Firebase-free hint that this browser has a signed-in OctoMail
 * session. The portal's AuthProvider keeps it in step with Firebase auth; the
 * public landing reads it to decide whether it is worth loading the Firebase
 * auth SDK (after idle) just to swap "Start free" for "Open OctoMail". First-time
 * visitors never download Firebase on the landing.
 */
const KEY = "om.signedIn";

export function setAuthHint(signedIn: boolean): void {
  try {
    if (signedIn) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* storage blocked */
  }
}

export function hasAuthHint(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * The last user the portal's AuthProvider saw in this tab (undefined until it
 * has run). Lets the landing show the right header at once after a client-side
 * navigation from /app back to /, instead of waiting for its own idle check.
 */
let lastUser: User | null | undefined;

export function rememberAuthUser(user: User | null): void {
  lastUser = user;
}

export function rememberedAuthUser(): User | null | undefined {
  return lastUser;
}
